export default __webpack_public_path__ + "8f958d073df94fba936e9819354ea3a1.png";